import { getSDK } from '@symbo-ls/workspace-shared/functions/sdk.js'

// Frank (the platform serializer) does not track destructured-parameter
// defaults (`{ title = 'x' } = {}`) as a locally-bound name — its free-var
// scanner sees `title` as unresolved and lifts it into the emitted
// globalScope, which then corrupts every OTHER bare `title:` object-literal
// key across the whole bundle via the peer-key rewrite pass (see
// tickets/smbls.md "frank's globalScope peer-key `this.`-rewrite corrupts
// object keys… that merely share a NAME with an unrelated globalScope peer").
// Plain property reads with explicit defaults avoid the destructuring shape
// entirely — same runtime behavior, no scanner blind spot. Exported (not
// underscore-only) so __tests__ can lock the defaulting contract without
// touching the SDK call below.
export const resolveKbArticleInput = (opts) => {
  const input = opts || {}
  const title = input.title === undefined ? 'Untitled article' : input.title
  const content = typeof input.content === 'string' ? input.content : ''
  return { title, content }
}

export const createKnowledgeArticle = async function (opts) {
  const resolved = resolveKbArticleInput(opts)
  const title = resolved.title
  const content = resolved.content
  const root = this.state.root
  const row = {
    title,
    body: content,
    author: root.currentUserEmail || 'Unknown'
  }
  let data
  try {
    const result = await getSDK().execute('docs.kbArticles', 'create', row)
    data = result?.data || result
  } catch (err) {
    console.error('[createKnowledgeArticle] insert failed', err)
    return null
  }
  const id = data?.docId || data?._id || data?.id
  if (!id) return null
  root.update({
    kbArticles: [
      ...(root.kbArticles || []),
      {
        id,
        title,
        content, // local state keeps the UI field name
        author: row.author,
        createdAt: new Date().toISOString().slice(0, 10)
      }
    ],
    selectedKbArticleId: id
  })
  this.call('forgetDocLists')
  return id
}
